export const DOCUMENT_MAX_SIZE = 64 * 1000 * 1000;
export const DOCUMENT_MIME_TYPES = [
    'application/pdf',
    'image/jpeg',
    'image/png',
    'image/webp',
    'image/tiff',
    'message/rfc822',
];
